import React from 'react';
import Shared from './shared/index';
import NotShared from './not-shared/index';
import SharedWithMe from './shared-with-me/index';

const Sprite = (props) => {debugger;
	switch (props.status) {
		case "SHARED":
			return <Shared width={props.width} height={props.height}/>;
		case "LICENSED":
			return <Shared width={props.width} height={props.height}/>;
		case "NOT_SHARED":
			return <NotShared width={props.width} height={props.height}/>;
		case "NOT_LICENSED":
			return <NotShared width={props.width} height={props.height}/>;
		case "SHARED_WITH_ME":
			return <SharedWithMe width={props.width} height={props.height}/>;
		default:
			break;
	}
};

export default Sprite;
